import React,{useEffect} from 'react';
import AboutHero from '../components/common/AboutHero';
import ContactStrip from '../components/common/ContactStrip';
import Recete3 from '../assets/images/recete3.jpg';
import AliUnsanlBashekim from '../assets/images/aliunsalbashekim.png';
import { toUrl } from '../lib/config';

const ImgWithFallback: React.FC<{ src?: string | null; alt: string; height?: number; style?: React.CSSProperties; className?: string }> = ({ src, alt, height = 70, style, className }) => {
  const baseIn = src || '';
  const m = baseIn.match(/([0-9a-fA-F-]{36})$/);
  const raw = m ? `/api/media/${m[1]}` : baseIn;
  const pref = toUrl(raw);
  const [currentSrc, setCurrentSrc] = React.useState(pref);
  return (
    <img
      src={currentSrc}
      alt={alt}
      className={className}
      style={{ height, objectFit: 'contain', borderRadius: 6, border: '1px solid #e5e7eb', background: '#fff', ...style }}
      crossOrigin="anonymous"
      onError={(e) => {
        const el = e.currentTarget as HTMLImageElement;
        const cur = el.getAttribute('src') || '';
        const next = cur === pref ? raw : pref;
        if (next !== cur) el.src = next;
      }}
    />
  );
};

const BashekimMesajiPage: React.FC = () => {
  const DEFAULT_DATA = {
    greeting: 'Değerli Hastalarımız,',
    content: 'Megapark Hastanesi olarak, sağlık hizmetlerinde kalite ve güveni bir arada sunma misyonuyla hizmet vermenin gururunu yaşıyoruz.\n\nHastanemiz, modern tıbbi teknolojiler ve uzman kadrosuyla, hastalarımıza en iyi sağlık hizmetini sunmayı hedeflemektedir. Hasta memnuniyeti ve güvenliği bizim için en öncelikli değerlerdir.\n\nDeneyimli hekimlerimiz, özveri ile çalışan sağlık personelimiz ve modern altyapımızla, sizlere en kaliteli sağlık hizmetini sunmak için var gücümüzle çalışmaktayız.',
    closing: 'Sağlıklı günler dilerim.',
    signature: 'Saygılarımla,',
    title: 'Başhekim',
    doctorName: ''
  };

  const [greeting, setGreeting] = React.useState<string>('');
  const [content, setContent] = React.useState<string>('');
  const [closing, setClosing] = React.useState<string>('');
  const [signature, setSignature] = React.useState<string>('');
  const [title, setTitle] = React.useState<string>('');
  const [doctorName, setDoctorName] = React.useState<string>('');
  const [loading, setLoading] = React.useState<boolean>(true);
  const [imageUrl, setImageUrl] = React.useState<string>('');

  const [heroKicker, setHeroKicker] = React.useState<string>('');
  const [heroTitle, setHeroTitle] = React.useState<string>('');
  const [heroDesc, setHeroDesc] = React.useState<string>('');
  const [heroLoading, setHeroLoading] = React.useState<boolean>(true);

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      try {
        setHeroLoading(true);
        const res = await fetch(toUrl('/api/page-hero/bashekim-mesaji'));
        if (!res.ok) throw new Error('fetch_failed');
        const data = await res.json();
        const obj = Array.isArray(data) ? (data[0] || {}) : (data || {});
        if (!cancelled) {
          setHeroKicker(obj.kicker || '');
          setHeroTitle(obj.title || '');
          setHeroDesc(obj.description || '');
        }
      } catch {
        // ignore
      }
      finally { if (!cancelled) setHeroLoading(false); }
    };
    run();
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    let cancelled = false;
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await fetch(toUrl('/api/bashekim-mesaji'));
        if (!res.ok) throw new Error('fetch_failed');
        const data = await res.json();
        if (!cancelled && data) {
          setGreeting(data.greeting || '');
          setContent(data.content || '');
          setClosing(data.closing || '');
          setSignature(data.signature || '');
          setTitle(data.title || '');
          setDoctorName(data.doctorName || '');
          setImageUrl(data.imageUrl || '');
        }
      } catch (err) {
        console.error('Başhekim mesajı yüklenemedi:', err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    fetchData();
    return () => { cancelled = true; };
  }, []);

  const contentParagraphs = (content || DEFAULT_DATA.content).split('\n\n');

  return (
    <>
      <AboutHero
        image={Recete3}
        kicker={heroKicker || "Kurumsal"}
        title={heroTitle || "Başhekim Mesajı"}
        description={heroDesc || "Hastanemiz başhekiminden sizlere mesaj"}
        overlayColor="#2cadd2"
        overlayOpacity={0.72}
        accentColor="#e30613"
        textColor="#2b2b2b"
        focus="center center"
        align="center"
        desktopHeight={460}
        tabletHeight={380}
        mobileHeight={320}
      />

      <section className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            {loading ? (
              <div style={{ padding: '24px 0', textAlign: 'center', color: '#6b7280' }}>
                Yükleniyor...
              </div>
            ) : (
              <div className="content-wrapper">
                <div className="text-center mb-4">
                  {imageUrl ? (
                    <ImgWithFallback
                      src={imageUrl}
                      alt="Megapark Hastanesi"
                      style={{ maxWidth: '100%', width: '500px', height: 'auto' }}
                    />
                  ) : (
                    <img src={AliUnsanlBashekim} alt="Megapark Hastanesi" style={{ maxWidth: '100%', width: '500px', height: 'auto' }} />
                  )}
                </div>
                <h2 className="mb-4" style={{ color: '#2cadd2' }}>
                  {greeting || DEFAULT_DATA.greeting}
                </h2>
                
                {contentParagraphs.map((paragraph, index) => (
                  <p key={index} className={index === 0 ? 'lead mb-4' : 'mb-4'}>
                    {paragraph}
                  </p>
                ))}

                <p className="mb-4">
                  {closing || DEFAULT_DATA.closing}
                </p>

                <div className="mt-5">
                  <p className="fw-bold mb-1">{signature || DEFAULT_DATA.signature}</p>
                  <p className="text-muted">{title || DEFAULT_DATA.title}</p>
                  {(doctorName || DEFAULT_DATA.doctorName) && (
                    <p className="fw-bold mt-2">{doctorName || DEFAULT_DATA.doctorName}</p>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      <ContactStrip />
    </>
  );
};

export default BashekimMesajiPage;
